<template>
  <div>
    <div class="title mt-5">
      <h3 class="d-flex justify-content-center header">
        {{$t('headers.hearing_test')}}
      </h3>
    </div>
    <div class="content">
      
      <div class="results-wrapper">
        <div class="d-flex justify-content-center mt-5">
          <span class="header header-2">{{resultText}}</span>
        </div>

        <div class="d-flex justify-content-center mt-3">
          <span class="header header-4">{{secondaryResultText}}</span>
        </div>

        <div class="d-flex justify-content-center mt-5">
          <button type="button" class="button primary" @click="$emit('continue')">{{$t('actions.contact_me')}}</button>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  props: {
    hasHearingLoss: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {}
  },
  methods: {},
  computed: {
    resultText: function () {
      if (this.hasHearingLoss) {
        return this.$t('results_stage.hearing_loss.has_loss')
      }
      return this.$t('results_stage.hearing_loss.ok')
    },
    secondaryResultText: function () {
      return this.hasHearingLoss ? this.$t('results_stage.recommendations.schedule') : this.$t('results_stage.recommendations.yearly_test')
    }
  }
}
</script>
<style scoped>
.results-wrapper {
  margin-top: 5rem;
}
</style>